import {
  faCaretDown,
  faCaretRight,
  faClipboardCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import DualColumnSelector from 'view/components/common/ItemSelector';
import Classroom from 'models/Classroom';

interface ClassroomSelectorProps {
  selectedClassrooms?: Classroom[];
  classroomOptions: Classroom[];
  onUpdateSelectedClassrooms: (selectedClassrooms: Classroom[]) => void;
}

type SelectableClassroom = {
  classroom: Classroom;
  selected: boolean;
  visible: boolean;
};

const ClassroomSelector: React.FC<ClassroomSelectorProps> = ({
  selectedClassrooms,
  classroomOptions,
  onUpdateSelectedClassrooms,
}) => {
  const [showClassroomSelector, setShowClassroomSelector] =
    useState<boolean>(false);
  const [classrooms, setClassrooms] = useState<SelectableClassroom[]>([]);

  useEffect(() => {
    if (!classroomOptions) return;
    setClassrooms(
      classroomOptions.map((c) => ({
        classroom: c,
        selected:
          selectedClassrooms?.find((cl) => cl.id === c.id) !== undefined,
        visible: true,
      })),
    );
  }, [classroomOptions, selectedClassrooms]);

  const handleAddClassroom = (classroom: SelectableClassroom) => {
    setClassrooms((prev: any) => {
      const index = prev.findIndex((c: any) => c === classroom);
      if (index === -1) return;
      const updatedClassrooms = prev.slice();
      updatedClassrooms[index] = { ...classroom, selected: true };
      onUpdateSelectedClassrooms(
        updatedClassrooms
          .filter((c: any) => c.selected)
          .map((c: any) => c.classroom),
      );
      return updatedClassrooms;
    });
  };

  const handleRemoveClassroom = (classroom: SelectableClassroom) => {
    setClassrooms((prev: any) => {
      const index = prev.findIndex((c: any) => c === classroom);
      if (index === -1) return;
      const updatedClassrooms = prev.slice();
      updatedClassrooms[index] = { ...classroom, selected: false };
      onUpdateSelectedClassrooms(
        updatedClassrooms
          .filter((s: any) => s.selected)
          .map((s: any) => s.classroom),
      );
      return updatedClassrooms;
    });
  };

  return (
    <div className="assignment-attribute-container">
      <div className="sidebar-text">
        <FontAwesomeIcon icon={faClipboardCheck} />
        <label className="label-normal">Assign to</label>
      </div>
      <div
        className="row sidebar-text"
        onClick={() => setShowClassroomSelector((prev) => !prev)}
      >
        <FontAwesomeIcon
          icon={showClassroomSelector ? faCaretDown : faCaretRight}
        />
        <label className="label-small">Custom selection</label>
      </div>
      {showClassroomSelector && (
        <DualColumnSelector
          items={classrooms}
          selectedItems={classrooms.filter((s) => s.selected)}
          style={{}}
          getId={(item: SelectableClassroom) => item.classroom.id}
          renderItem={(item: SelectableClassroom) => (
            <div className="user-info-dropdown-row">
              <div className="user-display-name">
                <span className="label-medium">{item.classroom.name}</span>
                <span className="label-small">({item.classroom.id})</span>
              </div>
            </div>
          )}
          filterItem={(items, searchTerm) =>
            items.filter((item) =>
              `${item.classroom.name} ${item.classroom.id}`
                .toLowerCase()
                .includes(searchTerm.toLowerCase()),
            )
          }
          onAddItem={handleAddClassroom}
          onRemoveItem={handleRemoveClassroom}
        />
      )}
    </div>
  );
};

export default ClassroomSelector;
